export default class subscriberInformation {
    constructor() {
        return {
            scope: {
                subscriber: "="
            },
            template: require('../../../../views/subscriber/show/subscriber-information.html'),
            controller: [
                '$scope', '$element', '$attrs', '$stateParams', '$filter', 'Language', 'Events', 'SweetAlert', 'Subscriber',
                (scope, element, attr, $stateParams, $filter, Language, Events, SweetAlert, Subscriber) => {

                scope.toggler = {
                    information: true,
                    tags: true,
                    segments: true
                };

                scope.toggleSize = (type) => {
                    scope.toggler[type] = ! scope.toggler[type];
                };

                scope.updateSubscriberInfo = () => {
                    var attributes = {
                        email: scope.subscriber.email,
                        phone_number: scope.subscriber.phone_number
                    };

                    Subscriber.update($stateParams.id, attributes).then(() => {
                        Events.flashEvent('notification', $filter('translate')('SUBSCRIBER:FLASH:UPDATED'));
                    }, (error) => {
                        if (error.status == 409) {
                            Events.flashEvent('error', $filter('translate')('SUBSCRIBER:FLASH:DUPLICATE'));
                        } else {
                            Events.flashEvent('error', $filter('translate')('SUBSCRIBER:FLASH:FAILED_UPDATE'));
                        }
                    })
                };

                scope.setLanguage = () => {
                    var language = scope.subscriber.language ? scope.subscriber.language.data.id : null;
                    Subscriber.setLanguage($stateParams.id, language).then(() => {
                        Events.flashEvent('notification', $filter('translate')('SUBSCRIBER:FLASH:UPDATED'));
                    }, (error) => {
                        Events.flashEvent('error', $filter('translate')('SUBSCRIBER:FLASH:FAILED_UPDATE'));
                    });
                };

                scope.removeTag = (tag, index) => {
                    SweetAlert.swal({
                            title: $filter('translate')('SUBSCRIBER_MODAL:TAG:DELETE'),
                            text: $filter('translate')('SUBSCRIBER_MODAL:TAG:DELETE_EXPLAINED'),
                            type: 'warning',
                            showCancelButton: true,
                            confirmButtonText: $filter('translate')('GLOBAL:YES'),
                            cancelButtonText: $filter('translate')('GLOBAL:NO')
                        },
                        (isConfirm) => {
                            if (isConfirm) {
                                Subscriber.removeTag(scope.subscriber.id, tag.id).then(() => {
                                    Events.flashEvent('notification', $filter('translate')('SUBSCRIBER_MODAL:TAG:REMOVED'));
                                    scope.subscriber.tags.data.splice(index, 1);
                                }, () => {
                                    Events.flashEvent('error', $filter('translate')('SUBSCRIBER_MODAL:TAG:REMOVED_FAILED'));
                                })
                            }
                        }
                    )
                };

                Language.all().then((response) => {
                    scope.languages = response.languages;
                });

                scope.$watch('newTags', (newVal) => {
                    if (! newVal || ! newVal.length) {
                        return
                    }

                    Subscriber.addTag($stateParams.id, scope.newTags[0]).then((result) => {
                        scope.subscriber.tags.data.push(result.data);

                        scope.clearTags = true;
                        scope.addTag = false;
                    }, (error) => {
                        Events.flashEvent('error', $filter('translate')('SUBSCRIBER:FLASH:ALREADY_HAS_TAG'));
                        scope.clearTags = true;
                        scope.addTag = false;
                    })
                });

            }]
        };
    }
}